import React, { useState } from "react";
import { showError, showSuccess } from "../../toastify";
import axios from "axios";

export const GenerateRandomPswd = (props) => {
  const { userId } = props;
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [didCopied, setDidCopied] = useState(false);
  const fetchPassword = async () => {
    setLoading(true);
    try {
      setDidCopied(false);
      const { data } = await axios.post("/api/auth/generate-default-password", {
        userId: userId,
      });
      setPassword(data);
    } catch (error) {
      showSuccess("Failed to fetch password");
    } finally {
      setLoading(false);
    }
  };

  const copyPassword = async () => {
    try {
      await navigator.clipboard.writeText(password);
      setDidCopied(true);
      showSuccess("Password copied!");
    } catch {
      showError("Copy failed.");
    }
  };

  return (
    <>
      <div style={styles.container}>
        {password && (
          <div style={styles.passwordBox}>
            <input
              type="text"
              value={password}
              readOnly
              style={styles.input}
              placeholder="Click fetch"
              onCopy={() => copyPassword}
            />
            <button
              onClick={copyPassword}
              className={`btn btn-${didCopied ? "success" : "secondary"}`}
            >
              {didCopied ? "Copied" : "Copy"}
            </button>
          </div>
        )}

        <button
          onClick={fetchPassword}
          className="btn btn-primary"
          style={{ marginTop: "10px" }}
        >
          {loading ? "Fetching..." : "Get Default Password"}
        </button>
      </div>
    </>
  );
};
const styles = {
  container: {
    maxWidth: "400px",
    margin: "50px auto",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
  },
  passwordBox: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  input: {
    flex: 1,
    padding: "10px",
    fontSize: "16px",
  },
  button: {
    padding: "10px 15px",
    fontSize: "14px",
    cursor: "pointer",
    border: "none",
    backgroundColor: "#007bff",
    color: "#fff",
    borderRadius: "5px",
  },
};

export default GenerateRandomPswd;
